import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PedidoFormBase } from './pedido-form.base';
import { SelectComponent } from '../../../components/select/select.component';
import { NgClass } from '@angular/common';
import { FieldErrorComponent } from '../../../components/field-error/field-error.component';
import { DateMaskDirective } from '../../../directives/date-mask.directive';
import { FormsModule } from '@angular/forms';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-pedido-form-fields',
    templateUrl: './pedido-form-fields.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectComponent,
        NgClass,
        FieldErrorComponent,
        DateMaskDirective,
        FormsModule,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatSuffix,
        MatDatepicker,
        PopoverDirective,
    ],
})
export class PedidoFormFieldsComponent {
  @Input() form: PedidoFormBase;
}
